import { Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { CheckBoxArrayDisplay } from './CheckBoxArrayDisplay';

type OptionLabels = {
  main: string;
  secondary?: string;
};

interface Props {
  value?: string[];
  previousValue?: string[] | null;
  onClose: () => void;
  fieldName: string;
  options: Record<string, OptionLabels>;
  dataAvailabilityTextValue?: string;
  previousDataAvailabilityTextValue?: string | null;
  dataAvailabilityTextLabel?: string;
}

export const CheckBoxArrayDiffModal = ({
  value,
  previousValue,
  onClose,
  fieldName,
  options,
  dataAvailabilityTextValue,
  previousDataAvailabilityTextValue,
  dataAvailabilityTextLabel
}: Props) => {
  const hasTextValues =
    dataAvailabilityTextValue || previousDataAvailabilityTextValue;
  const prevZeroState =
    !previousValue ||
    (previousValue.length === 0 && !previousDataAvailabilityTextValue);
  const currentZeroState =
    !value || (value.length === 0 && !dataAvailabilityTextValue);

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {fieldName} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={fieldName}>
        {prevZeroState ? (
          zeroState
        ) : (
          <Flex flexDirection="column" gap={2}>
            {previousValue && previousValue.length > 0 && (
              <CheckBoxArrayDisplay value={previousValue} options={options} />
            )}
            {previousDataAvailabilityTextValue && (
              <Text textStyle="textBody">
                <i>Additional Details: </i>
                {hasTextValues && dataAvailabilityTextLabel
                  ? `${dataAvailabilityTextLabel} `
                  : ''}
                {previousDataAvailabilityTextValue}
              </Text>
            )}
          </Flex>
        )}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={fieldName}>
        {currentZeroState ? (
          zeroState
        ) : (
          <Flex flexDirection="column" gap={2}>
            {value && value.length > 0 && (
              <CheckBoxArrayDisplay value={value} options={options} />
            )}
            {dataAvailabilityTextValue && (
              <Text textStyle="textBody">
                <i>Additional Details: </i>
                {hasTextValues && dataAvailabilityTextLabel
                  ? `${dataAvailabilityTextLabel} `
                  : ''}
                {dataAvailabilityTextValue}
              </Text>
            )}
          </Flex>
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
